import React from 'react'

/** Small "i" bubble with a hover explanation — reuses the app's daisyUI tooltip pattern (data-tip). */
export const InfoTip: React.FC<{ tip: string; pos?: string }> = ({ tip, pos = 'tooltip-bottom' }) => (
  <span className={`tooltip ${pos} align-middle ml-1 normal-case font-normal`} data-tip={tip}>
    <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-gray-200 text-[10px] font-bold text-gray-600 cursor-help">
      i
    </span>
  </span>
)
